import { render, staticRenderFns } from "./HeaderEdits.vue?vue&type=template&id=027002f8&scoped=true"
import script from "./HeaderEdits.vue?vue&type=script&lang=js"
export * from "./HeaderEdits.vue?vue&type=script&lang=js"
import style0 from "./HeaderEdits.vue?vue&type=style&index=0&id=027002f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027002f8",
  null
  
)

export default component.exports